import styled from '@emotion/styled'
import React, { useCallback } from 'react'
import { useToastForReactQuery, useVisible } from '../../../../utils/custom-hooks'
import Button from '../../../components/common/Button'
import DialogExportKycFilter, { ExportKycFilterFormValues } from './DialogExportKycFilter'
import { useExportKycReport } from '../../../services/kyc/kyc-query'
import 'react-toastify/dist/ReactToastify.css'
import { ExportKycReportParams } from '../../../services/kyc/kyc-typed'

const Layout = styled.div`
  display: flex;
  flex: 1;
  flex-flow: row;
  align-items: center;
  justify-content: flex-end;
  height: 100%;
  padding-right: 16px;
`
const ButtonStyled = styled(Button)`
  padding: 7px 13px;
`

const ExportKycReportButton = () => {
  const { visible, open, close } = useVisible()

  const { mutate: exportKycReport } = useExportKycReport()
  const toast = useToastForReactQuery()

  const onExportClick = useCallback(
    (values: ExportKycFilterFormValues) => {
      const { filterRange, status } = values
      const { endDate, startDate } = filterRange || {}
      if (startDate && endDate) {
        const params: ExportKycReportParams = {
          startDate,
          endDate,
          status: status?.value ? status?.value : undefined,
        }

        const toastId = toast.open('Exporting...')
        exportKycReport(params, {
          onSuccess: () => {
            toast.onSuccess(toastId)
          },
          onError: error => {
            toast.onError(toastId, error)
          },
        })
      }
      close()
    },
    [close, toast, exportKycReport],
  )
  const onClose = useCallback(() => {
    close()
  }, [close])

  return (
    <Layout>
      <ButtonStyled variant="warning" onClick={open}>
        Export
      </ButtonStyled>
      <DialogExportKycFilter visible={visible} onClose={onClose} onSubmit={onExportClick} />
    </Layout>
  )
}

export default ExportKycReportButton
